export function h3d(_ctx) {
    return {
        styles: {
            main: {
                bg_color: '#000000ff',
                border_color: '#ffffffff',
                border_width: 2,
                outline_color: '#ffffffff',
                shadow_color: '#00000066',
                radius: 5,
            },
        },
    };
}
